export const apiKey = {
  SERVICE_ID: `service_m2g6g9h`,
  TEMPLATE_ID: `template_6m9zkvc`,
  USER_ID: `UFyGO9AW5bbQSpj6t`,
}
